export const stringMapDefault = {
    backLabel: "Back",
    // TODO: move back to a prop
    nestedGroupLabel: "{label}",
    viewNestedAriaLabel: "View nested items",
    detailsLabel: "Information, {label}",
    detailsCloseLabel: "Close",
    hasAdditionalActionsHint: "has additional actions, press Tab to activate",
    hasDetailsHint: "has details, press Tab to activate",
    hasChildrenHint: "has nested items, press Tab and Enter to show"
};
